// import { Injectable } from '@angular/core';
//
// import { MainMenuItem } from './main-menu-item.model';
// import { MAINMENUITEMS } from './main-menu-items';
//
// @Injectable()
// export class MainMenuService {
//   getMainMenuItems(): Promise<MainMenuItem[]> {
//     return Promise.resolve(MAINMENUITEMS);
//   }
// }



import {Injectable} from '@angular/core';

import { MainMenuItem } from './main-menu-item.model';
import {MainMenu} from './mock-main-menu-items';

@Injectable()
export class MainMenuService {
  constructor(private menu: MainMenu) {}
  getMainMenuItems(): Promise<MainMenuItem[]> {
    return Promise.resolve(this.menu.getMainMenuItems());
  }
}




// WEBPACK FOOTER //
// ./src/app/home/pages/Dashboard/menus/main-menu/main-menu.service.ts